import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { asFormControl, TypedFormGroup } from '@feature/forms/form-model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { mediumTextMaxLength, WaiValidators } from '@feature/forms/wai-validators';

export interface NameDialogData {
  title: string;
  name: string;
}

export interface NameDialogResult {
  name: string;
}

@Component({
    selector: 'wai-name-dialog',
    templateUrl: './name-dialog.component.html',
    styleUrls: ['./name-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NameDialogComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  public form: FormGroup = this.buildForm();

  
  public asFormControl = asFormControl;
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public dialogData: NameDialogData,
    private dialogRef: MatDialogRef<NameDialogComponent, NameDialogResult>,
  ) {}

  public onSubmit(form: FormGroup): void {
    if (form.valid) {
      this.dialogRef.close({
        name: form.get('name').value,
      });
    }
  }

  private buildForm(): FormGroup {
    return this.formBuilder.group({
      name: [
        this.dialogData.name,
        [Validators.required, Validators.maxLength(mediumTextMaxLength), WaiValidators.nonEmpty],
      ],
    });
  }
}
